import React from 'react'
import { Box, Button, IconButton, Typography } from '@mui/material'
import { GridToolbarContainer } from '@mui/x-data-grid'
import PropTypes from 'prop-types'

import { Settings } from '../../../assets/icons/circles/Settings'
import CustomSearchbar from '../../../common/AbstractDataGrid/CustomSearchbar'
import MUIDataGrid from '../../../common/AbstractDataGrid/DataGridMUI'
import chips from '../../../common/ui/chips'
import { ColorBoxContent } from '../../../common/ui/colorBox'
import { formatDateToLocale } from '../../../helpers/date'

export default function UserAccount({
  customers,
  setIsAddUserModalOpen,
  setUserAccountDetails,
  setIsEditUserModalOpen,
  nextHandler,
  backHandler,
  variant
}) {
  // DATA GRID COMPONENT
  const rows = customers.users.map((userAccount) => {
    return {
      name: userAccount.name,
      _id: userAccount._id,
      id: userAccount._id,
      email: userAccount.email,
      role: userAccount.role,
      orgId: userAccount.orgId,
      contactNumber: userAccount.contactNumber,
      actions: userAccount.actions,
      createdAt: userAccount.createdAt
    }
  })

  const columns = [
    { field: 'name', headerName: 'Name', width: 150 },
    { field: 'email', headerName: 'Email', width: 150 },
    {
      field: 'role',
      headerName: 'Role',
      width: 50,
      renderCell: (params) => {
        const userAccount = params.row
        return chips.users[userAccount.role?.toUpperCase()]
      }
    },
    {
      field: 'createdAt',
      headerName: 'Joined',
      width: 100,
      renderCell: (params) => {
        const userAccount = params.row
        return formatDateToLocale(userAccount.createdAt)
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => {
        const userAccount = params.row
        return (
          <IconButton
            sx={{ color: 'darkblue' }}
            onClick={() => {
              setUserAccountDetails(userAccount)
              setIsEditUserModalOpen(true)
            }}
            data-cy='actionBtn'
          >
            <Settings />
          </IconButton>
        )
      }
    }
  ]

  const AccountToolbar = () => {
    return (
      <GridToolbarContainer
        sx={{
          justifyContent: 'space-between'
        }}
      >
        <CustomSearchbar />

        <div id='manageCustomers__addUserBtn'>
          <Button
            variant='filled'
            size='small'
            onClick={() => setIsAddUserModalOpen(true)}
            data-cy='addNewUserBtn'
          >
            Add New User
          </Button>
        </div>
      </GridToolbarContainer>
    )
  }

  return (
    <>
      <Typography variant='h4'>User Accounts</Typography>
      <ColorBoxContent style={{ marginTop: 8 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItem: 'center',
            mb: 1
          }}
        />
        <Box>
          <div id='manageAccounts__mainDiv' style={{ bottom: 0 }}>
            <MUIDataGrid
              rows={rows}
              columns={columns}
              components={{ Toolbar: AccountToolbar }}
            />
          </div>
        </Box>
        {variant === 'add-new-customer' ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end'
            }}
          >
            <Button
              variant='secondary'
              onClick={backHandler}
              data-cy='userAccBackBtn'
            >
              Back
            </Button>
            <Button
              variant='filled'
              onClick={nextHandler}
              data-cy='userAccCfmBtn'
            >
              Confirm
            </Button>
          </Box>
        ) : (
          ''
        )}
      </ColorBoxContent>
    </>
  )
}

UserAccount.propTypes = {
  customers: PropTypes.array,
  setIsAddUserModalOpen: PropTypes.bool,
  setUserAccountDetails: PropTypes.func,
  setIsEditUserModalOpen: PropTypes.func,
  nextHandler: PropTypes.func,
  backHandler: PropTypes.func,
  variant: PropTypes.string
}
